import GuidePageScreen, { generateStaticParams } from '@/components/Guides/GuidePageScreen';

export { generateStaticParams };
export default function LearnDynamicPage() {
  return <GuidePageScreen guideType="learn" />;
}
